import { iD3Data, iData } from "../types";

export const deleteD3Action = ({
    d3Data,
    relatedTo,
    data,
    setData
}: {
    d3Data: iD3Data;
    relatedTo: string;
    data: iData;
    setData: React.Dispatch<React.SetStateAction<iData>>;
}): iData => {
    const newDataObjects = data.objects.map((o: any) => {
        if (o._id === relatedTo) {
            o.isAction = false;
        }

        o.fields = o.fields.map(f => {
            if (f._id === relatedTo) {
                f.isAction = false;
            }

            return f
        })

        return o;
    });

    const newDataRels = data.relLinks.map((rl) => {
        if (rl._id === relatedTo) {
            rl.isAction = false;
        }

        return rl;
    });

    const newNodeRelationships = data.nodeRelationships.map((nr) => {
        if (nr._id === relatedTo) {
            nr.isAction = false;
        }

        return nr;
    });

    const newData = {
        ...data,
        objects: newDataObjects,
        relLinks: newDataRels,
        nodeRelationships: newNodeRelationships
    };

    setData(newData);
    return newData;
};
